import { Dispatch, SetStateAction } from "react";
import { Modal } from "../Modal/Modal";
import { GalleryObject } from "../utils/utils.ts";
import { Carousel } from "./Carousel";

export interface ZoomModalProps {
  onClose: () => void;
  mediaItems: GalleryObject[];
  selectedIndex: number;
  setSelectedIndex: Dispatch<SetStateAction<number>>;
  isOpen: boolean;
  videoAutoplayIndex: number | null;
}

export const ZoomModal = ({
  onClose,
  mediaItems,
  selectedIndex,
  setSelectedIndex,
  isOpen,
  videoAutoplayIndex,
}: ZoomModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Carousel
        mediaItems={mediaItems}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        videoAutoplayIndex={videoAutoplayIndex}
      />
    </Modal>
  );
};
